//App
import { LookupTypeApiType } from "./types/apiTypes";
import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";

const lookupTypeApi: LookupTypeApiType = {
  get: (value) => apiClient.get(endPoints.lookupType.get(value)),
  getAll: (payload) => apiClient.get(endPoints.lookupType.getAll(), payload),
  save: (payload) => apiClient.post(endPoints.lookupType.save(), payload),
  delete: (value) => apiClient.delete(endPoints.lookupType.delete(value)),
  activate: (value) => apiClient.post(endPoints.lookupType.activate(value)),
  searchLookupType: (payload) =>
    apiClient.post(endPoints.lookupType.searchLookupType(), payload),
};

export default lookupTypeApi;
